import React from 'react';
import { Translate } from 'react-jhipster';

import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="asterisk" to="/address">
        <Translate contentKey="global.menu.entities.address" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/agreement">
        <Translate contentKey="global.menu.entities.agreement" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/bank-account">
        <Translate contentKey="global.menu.entities.bankAccount" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/contact">
        <Translate contentKey="global.menu.entities.contact" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/correction-factor">
        <Translate contentKey="global.menu.entities.correctionFactor" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/customer">
        <Translate contentKey="global.menu.entities.customer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/customer-account">
        <Translate contentKey="global.menu.entities.customerAccount" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/customer-order">
        <Translate contentKey="global.menu.entities.customerOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/daily-product-usage">
        <Translate contentKey="global.menu.entities.dailyProductUsage" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/department">
        <Translate contentKey="global.menu.entities.department" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/dynamic-tariff">
        <Translate contentKey="global.menu.entities.dynamicTariff" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/ean">
        <Translate contentKey="global.menu.entities.ean" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/employee">
        <Translate contentKey="global.menu.entities.employee" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/error-message">
        <Translate contentKey="global.menu.entities.errorMessage" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/grid-operator">
        <Translate contentKey="global.menu.entities.gridOperator" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/grid-operator-capacity">
        <Translate contentKey="global.menu.entities.gridOperatorCapacity" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/grid-operator-capacity-tariff">
        <Translate contentKey="global.menu.entities.gridOperatorCapacityTariff" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/hourly-product-usage">
        <Translate contentKey="global.menu.entities.hourlyProductUsage" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/invoice">
        <Translate contentKey="global.menu.entities.invoice" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/login">
        <Translate contentKey="global.menu.entities.login" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/mandate">
        <Translate contentKey="global.menu.entities.mandate" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/meter">
        <Translate contentKey="global.menu.entities.meter" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/monthly-product-usage">
        <Translate contentKey="global.menu.entities.monthlyProductUsage" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/organisation">
        <Translate contentKey="global.menu.entities.organisation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product">
        <Translate contentKey="global.menu.entities.product" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-offering">
        <Translate contentKey="global.menu.entities.productOffering" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-offering-price">
        <Translate contentKey="global.menu.entities.productOfferingPrice" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-order">
        <Translate contentKey="global.menu.entities.productOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-process">
        <Translate contentKey="global.menu.entities.productProcess" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-process-history">
        <Translate contentKey="global.menu.entities.productProcessHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-specification">
        <Translate contentKey="global.menu.entities.productSpecification" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/relation-customer">
        <Translate contentKey="global.menu.entities.relationCustomer" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sector-calendar">
        <Translate contentKey="global.menu.entities.sectorCalendar" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/service-order">
        <Translate contentKey="global.menu.entities.serviceOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/supplier">
        <Translate contentKey="global.menu.entities.supplier" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tariff">
        <Translate contentKey="global.menu.entities.tariff" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tariff-history">
        <Translate contentKey="global.menu.entities.tariffHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/task">
        <Translate contentKey="global.menu.entities.task" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tax-tariff-tranche">
        <Translate contentKey="global.menu.entities.taxTariffTranche" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tax-tariff-tranche-history">
        <Translate contentKey="global.menu.entities.taxTariffTrancheHistory" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/work-order">
        <Translate contentKey="global.menu.entities.workOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/net-metering-policy">
        <Translate contentKey="global.menu.entities.netMeteringPolicy" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/signing-session">
        <Translate contentKey="global.menu.entities.signingSession" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/contract-signature">
        <Translate contentKey="global.menu.entities.contractSignature" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/signature-audit-log">
        <Translate contentKey="global.menu.entities.signatureAuditLog" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sub-captar">
        <Translate contentKey="global.menu.entities.subCaptar" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/product-tariff-override">
        <Translate contentKey="global.menu.entities.productTariffOverride" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tariff-pricing-constraint">
        <Translate contentKey="global.menu.entities.tariffPricingConstraint" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/contact-rms">
        <Translate contentKey="global.menu.entities.contactRms" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
